import { render, staticRenderFns } from "./health-and-safety-know-your-risks.vue?vue&type=template&id=f02191b8&"
import script from "./health-and-safety-know-your-risks.vue?vue&type=script&lang=js&"
export * from "./health-and-safety-know-your-risks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports